module.exports = __webpack_public_path__ + "img/ques.bd54abf4.png";